import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import './style.css'
import { AppState } from '../../redux/states/appState'
import { injectIntl } from 'react-intl'
import { StoresDispatcher } from '../../redux/dispatchers/stores'
import { ReactComponent as CloseIcon } from '../../utils/icons/elements-icon-close.svg'
import { Button } from 'primereact/button'
import ModalFullScreen from '../modal-full-screen/ModalFullScreen'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import IconButton from '../icon-button/IconButton'
import { PhotosApi } from '../../utils/api/photosApi'
import { getAllPhotos } from '../../redux/actions/photos'
import { getDefaultThumbnails } from '../../redux/actions/photos'
import moment from 'moment'
import { getMultipleStores, getSingleStore } from '../../redux/actions/stores'
import { dateFormatter } from '../../utils/commonFunctions'
import GalleryModal from '../store-details/gallery-modal/GalleryModal'
import { SidebarMenuKind } from '../../models/sidebar-menu-kind'

const TITLE_ID = 'compare_selected_stores'

// Wrapper component per aggiungere informazioni del negozio al GalleryModal
const CompareGalleryModal = (props: any) => {
    const { storeInfo, intl, ...galleryModalProps } = props

    return (
        <div>
            <GalleryModal {...galleryModalProps} />
            {storeInfo && (
                <div
                    style={{
                        position: 'fixed',
                        top: '20px',
                        right: '20px',
                        background: 'rgba(255, 255, 255, 0.95)',
                        padding: '12px 16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        zIndex: 1001,
                        fontSize: '14px',
                        color: '#333',
                    }}>
                    <div style={{ marginBottom: '4px' }}>
                        <strong>Store ID:</strong> {storeInfo.id}
                    </div>
                    {storeInfo.openDate && (
                        <div>
                            <strong>Data apertura:</strong>{' '}
                            {dateFormatter(storeInfo.openDate)}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

const CompareStoresBar = (props: { intl: any }) => {
    const { intl } = props
    const dispatch = useDispatch()
    const [isCompareOpen, setIsCompareOpen] = useState(false)
    const [slideIdx, setSlideIdx] = useState<Record<string, number>>({})
    const [zoomStoreId, setZoomStoreId] = useState<string | null>(null)
    const [zoomCarouselState, setZoomCarouselState] = useState({
        page: 0,
        tab: 'all',
    })

    // carica foto dei negozi selezionati quando apro il confronto
    useEffect(() => {
        if (isCompareOpen) {
            dispatch(
                getMultipleStores(
                    storesToCompare.map((st) => st.store_id_string)
                )
            )
            const missingIds = storesToCompare
                .filter(
                    (st) =>
                        !photos.some(
                            (p: any) =>
                                p.store_id?.endsWith(st.store_id_string) ||
                                p.store_id === st.store_id_string
                        )
                )
                .map((st) => st.store_id_string)

            if (missingIds.length > 0 && missingIds.length <= 3) {
                const today = moment()
                const aYearAgo = moment().subtract(1, 'year')
                dispatch(
                    // @ts-ignore tipo dates compatibile con getAllPhotos
                    getAllPhotos(missingIds, [
                        {
                            from: aYearAgo.valueOf().toString(),
                            to: today.valueOf().toString(),
                        },
                    ])
                )
            }
        } else {
            // prefetch thumbnails for stores to compare if not present
            const missingThumbIds = storesToCompare
                .filter(
                    (st) =>
                        !thumbnails.some(
                            (t: any) =>
                                t.store_id === st.store_id_string ||
                                t.store_id?.endsWith(st.store_id_string)
                        )
                )
                .map((st) => st.store_id_string)

            if (missingThumbIds.length > 0) {
                const today = moment()
                const aYearAgo = moment().subtract(1, 'year')
                dispatch(
                    // @ts-ignore
                    getDefaultThumbnails(missingThumbIds, [
                        {
                            from: aYearAgo.valueOf().toString(),
                            to: today.valueOf().toString(),
                        },
                    ])
                )
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCompareOpen])

    const storesToCompare = useSelector(
        (state: AppState) => state.storesReducer.storesToCompare
    )
    const selectedStoresToCompare = useSelector(
        (state: AppState) => state.storesReducer.selectedStoresToCompare
    )
    const thumbnails = useSelector(
        (state: AppState) => state.photosReducer.thumbnailList
    )
    const photos = useSelector(
        (state: AppState) => state.photosReducer.photoList
    )

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
    }

    const preparePhotoDataForZoom = (storeId: string) => {
        const storePhotos = photos.filter(
            (p: any) => p.store_id === storeId || p.store_id?.endsWith(storeId)
        )
        const storeThumbs = thumbnails.filter(
            (t: any) => t.store_id === storeId || t.store_id?.endsWith(storeId)
        )

        const formatStoreId = (id: string) => {
            if (id.includes('500-000000')) {
                return id
            }
            return `500-000000${id}`
        }

        const photoList =
            storePhotos.length > 0
                ? storePhotos.map((p: any, index: number) => ({
                      ...p,
                      index,
                      macroarea: 'all',
                      store_id: formatStoreId(p.store_id || storeId),
                      id: p.id || `${storeId}_${index}`,
                  }))
                : storeThumbs.length > 0
                ? storeThumbs.map((t: any, index: number) => ({
                      ...t,
                      index,
                      macroarea: 'all',
                      store_id: formatStoreId(t.store_id || storeId),
                      id: t.id || `${storeId}_thumb_${index}`,
                  }))
                : [
                      {
                          url: '/image@3x.png',
                          index: 0,
                          macroarea: 'all',
                          store_id: formatStoreId(storeId),
                          id: `${storeId}_placeholder`,
                      },
                  ]

        const photoInSections = {
            all: {
                list: photoList,
            },
        }

        return { photoList, photoInSections }
    }

    const isFilterBarOpen = useSelector(
        (state: AppState) =>
            state.filtersReducer.selectedSidebarMenu !== SidebarMenuKind.NONE
    )

    return (
        <div
            className="compareStoresBar"
            style={{
                width: isFilterBarOpen
                    ? window.innerWidth - 496
                    : window.innerWidth,
            }}>
            <div className="compareStoresBarHeader">
                <div className="header">
                    <div className="title">
                        {intl.formatMessage({ id: TITLE_ID })} (
                        {storesToCompare.length} / 3)
                    </div>

                    <div className="compareStoresBarCloseBtn">
                        <IconButton
                            icon="times"
                            label=""
                            tooltipIntl="close"
                            onClick={() =>
                                dispatch(
                                    StoresDispatcher.SetCompareMode({
                                        isCompareMode: false,
                                    })
                                )
                            }
                        />
                    </div>
                </div>
                <div className="compareStoresBarStoresContainer">
                    <div className="compareStoresBarStores">
                        {storesToCompare.map((store) => {
                            // prefer first full photo url if available
                            const primaryPhoto = photos.find(
                                (p: any) =>
                                    p.store_id === store.store_id_string ||
                                    p.store_id?.endsWith(store.store_id_string)
                            )?.url

                            const thumb =
                                primaryPhoto ||
                                thumbnails.find(
                                    (t) =>
                                        t.store_id === store.store_id_string ||
                                        t.store_id?.endsWith(
                                            store.store_id_string
                                        )
                                )?.url ||
                                '/image@3x.png'
                            return (
                                <div
                                    key={store.store_id_string}
                                    className="store">
                                    <img
                                        src={thumb}
                                        alt={store.store_id_string}
                                    />
                                    <div
                                        className="removeBtn"
                                        onClick={() =>
                                            dispatch(
                                                StoresDispatcher.RemoveStoreFromCompare(
                                                    {
                                                        store,
                                                    }
                                                )
                                            )
                                        }>
                                        <CloseIcon />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <Button
                        label={intl.formatMessage({
                            id: 'compare_stores_bar_button_compare',
                        })}
                        onClick={() => setIsCompareOpen(true)}
                    />
                </div>
            </div>
            {/* Modal di confronto full-screen */}
            <ModalFullScreen
                open={isCompareOpen}
                onHide={() => setIsCompareOpen(false)}>
                <div className="compareModalContent">
                    {selectedStoresToCompare.map((store) => {
                        const storePhotos = photos.filter(
                            (p: any) =>
                                p.store_id === store.store_id_string ||
                                p.store_id?.endsWith(store.store_id_string)
                        )

                        const hasPhotos = storePhotos.length > 0

                        const storeThumbs = thumbnails.filter(
                            (t: any) =>
                                t.store_id === store.store_id_string ||
                                t.store_id?.endsWith(store.store_id_string)
                        )

                        const hasThumbs = storeThumbs.length > 0

                        const imageUrls = hasPhotos
                            ? storePhotos.map((p: any) => p.url)
                            : hasThumbs
                            ? storeThumbs.map((t: any) => t.url)
                            : ['/image@3x.png']

                        return (
                            <div
                                className="compareColumn"
                                key={store.store_id_string}>
                                <div className="compareCarousel">
                                    {(hasPhotos || hasThumbs) && (
                                        <div className="compareColumnActions">
                                            <IconButton
                                                icon="download"
                                                label=""
                                                tooltipIntl="store_detail.download_photo"
                                                onClick={() => {
                                                    const idx =
                                                        slideIdx[
                                                            store
                                                                .store_id_string
                                                        ] ?? 0
                                                    const firstUrl =
                                                        imageUrls[idx]
                                                    if (!firstUrl) return
                                                    // se abbiamo Photo completo usiamo API, altrimenti facciamo download grezzo
                                                    const p = storePhotos.find(
                                                        (ph: any) =>
                                                            ph.url === firstUrl
                                                    )
                                                    if (p) {
                                                        PhotosApi.downloadSinglePhoto(
                                                            p,
                                                            intl
                                                        )
                                                    } else {
                                                        fetch(firstUrl)
                                                            .then((resp) =>
                                                                resp.blob()
                                                            )
                                                            .then((blob) => {
                                                                const urlObj =
                                                                    URL.createObjectURL(
                                                                        blob
                                                                    )
                                                                const link =
                                                                    document.createElement(
                                                                        'a'
                                                                    )
                                                                link.href =
                                                                    urlObj
                                                                link.download = `${store.store_id_string}.jpg`
                                                                document.body.appendChild(
                                                                    link
                                                                )
                                                                link.click()
                                                                document.body.removeChild(
                                                                    link
                                                                )
                                                                URL.revokeObjectURL(
                                                                    urlObj
                                                                )
                                                            })
                                                    }
                                                }}
                                                style={{
                                                    backgroundColor: '#E0ECF0',
                                                }}
                                                intl={intl}
                                            />
                                            <IconButton
                                                icon="search-plus"
                                                label=""
                                                tooltipIntl="zoom"
                                                onClick={() => {
                                                    const currentSlideIndex =
                                                        slideIdx[
                                                            store
                                                                .store_id_string
                                                        ] ?? 0
                                                    setZoomCarouselState({
                                                        page: currentSlideIndex,
                                                        tab: 'all',
                                                    })
                                                    setZoomStoreId(
                                                        store.store_id_string
                                                    )
                                                }}
                                                style={{
                                                    backgroundColor: '#5C92E5',
                                                    color: 'white',
                                                }}
                                                intl={intl}
                                            />
                                        </div>
                                    )}
                                    <Slider
                                        {...sliderSettings}
                                        beforeChange={(
                                            _: number,
                                            newIndex: number
                                        ) =>
                                            setSlideIdx((prev) => ({
                                                ...prev,
                                                [store.store_id_string]:
                                                    newIndex,
                                            }))
                                        }>
                                        {imageUrls.map(
                                            (url: string, idx: number) => (
                                                <div
                                                    key={idx}
                                                    className="slideImgWrapper">
                                                    <img
                                                        src={url}
                                                        alt={`store-${store.store_id_string}-${idx}`}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </Slider>
                                </div>
                                <div className="compareInfos">
                                    <p>
                                        <strong>Store name:</strong>{' '}
                                        {store.store_name_string}
                                    </p>
                                    <p>
                                        <strong>Store ID:</strong> {store.id}
                                    </p>
                                    <p>
                                        <strong>Banner:</strong>{' '}
                                        {store.banner_desc_string}
                                    </p>
                                    <p>
                                        <strong>Macroregion:</strong>{' '}
                                        {store.macroregion_desc_string ||
                                            store.macroregion_string}
                                    </p>
                                    <p>
                                        <strong>Country:</strong>{' '}
                                        {store.city_string}
                                        {store.region_string &&
                                            `, ${store.region_string}`}
                                    </p>
                                    <p>
                                        <strong>Channel of trade:</strong>{' '}
                                        {store.channel_of_trade_string}
                                    </p>
                                    <p>
                                        <strong>Host name:</strong>{' '}
                                        {store.store_host_name_string}
                                    </p>
                                    <p>
                                        <strong>Segment:</strong>{' '}
                                        {store.segment_string}
                                    </p>
                                    <p>
                                        <strong>Store design family:</strong>{' '}
                                        {store.store_design_group_string ||
                                            store.store_design_string}
                                    </p>
                                    <p>
                                        <strong>Data di apertura:</strong>{' '}
                                        {dateFormatter(store.open_date_long)}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </ModalFullScreen>
            {zoomStoreId &&
                (() => {
                    const { photoList, photoInSections } =
                        preparePhotoDataForZoom(zoomStoreId)
                    const currentStore = storesToCompare.find(
                        (store) => store.store_id_string === zoomStoreId
                    )

                    return (
                        <CompareGalleryModal
                            open={true}
                            close={() => setZoomStoreId(null)}
                            photoInSections={photoInSections}
                            photoList={photoList}
                            store={{
                                name: currentStore?.store_name_string || '',
                                id:
                                    currentStore?.id ||
                                    currentStore?.store_id_string ||
                                    '',
                            }}
                            carouselState={zoomCarouselState}
                            setCarouselState={setZoomCarouselState}
                            isApp={false}
                            banner={currentStore?.banner_desc_string || ''}
                            storeName={currentStore?.store_name_string || ''}
                            storeInfo={{
                                id:
                                    currentStore?.id ||
                                    currentStore?.store_id_string ||
                                    '',
                                openDate: currentStore?.open_date_long,
                            }}
                            intl={intl}
                        />
                    )
                })()}
        </div>
    )
}

export default injectIntl(CompareStoresBar)

